import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { i18n } from '@international/mastodon-i18n';
import 'scss/MvrMatrixDocumentUpload.scss';
import DOMPurify from 'isomorphic-dompurify';
import { DETAIL_LIST } from './mvrMatrixConstants';

// Any field names listed here are read from matrix item configuration
// and made available as variables when resolving translation strings
const I18N_VAR_NAMES = ['jurisdiction'];

class MvrMatrixDocumentUploadDetail extends Component {
  renderDetailList = translationPrefix => {
    const { matrixField, t: i18nTranslate } = this.props;
    const { jurisdiction } = matrixField;

    let items = i18nTranslate(
      `${translationPrefix}.instruction.${jurisdiction}.items`,
      { returnObjects: true },
    );

    if (!this.hasTranslations(items)) {
      items = i18nTranslate(`${translationPrefix}.instruction.default.items`, {
        returnObjects: true,
      });
    }

    return (
      <ul className='details-list'>
        {items.map((item, i) => (
          <li
            key={`item-${i + 1}`}
            className='details-list-item'
            data-testid={`upload-details-instruction-${i}`}
          >
            {`${item.text} `}
            {item.link && (
              <a href={item.link.url} target='_blank' rel='noopener noreferrer'>
                {item.link.text}
              </a>
            )}
          </li>
        ))}
      </ul>
    );
  };

  i18nVarsFromField = matrixField => {
    return Object.entries(matrixField).reduce((outVars, kv) => {
      const [k, v] = kv;
      if (I18N_VAR_NAMES.includes(k)) {
        outVars[k] = DOMPurify.sanitize(v);
      }
      return outVars;
    }, {});
  };

  hasTranslations(items) {
    // items will be a string if jurisdiction is not found in portal_XX.json
    // eg components.Report.Verification.MatrixVerification
    // .driver_abstract_documentation_requested.instruction.not Found.items
    return Array.isArray(items);
  }

  renderDetailsParagraph = (matrixField, translationPrefix) => {
    return (
      <p
        className='details-paragraph'
        data-testid='upload-details'
        dangerouslySetInnerHTML={{
          __html: i18n.getStr(
            `${translationPrefix}.details`,
            this.i18nVarsFromField(matrixField),
          ),
        }}
      />
    );
  };

  renderSubtitle = (matrixField, translationPrefix) => {
    const subtitle = i18n.getStr(
      `${translationPrefix}.subtitle`,
      this.i18nVarsFromField(matrixField),
    );

    if (!subtitle || subtitle.includes('.subtitle')) return null;

    return (
      <h6
        style={{ fontWeight: 'normal' }}
        className='details-subtitle'
        data-testid='upload-subtitle'
      >
        {subtitle}
      </h6>
    );
  };

  renderInstructions = translationPrefix => {
    const { t: i18nTranslate } = this.props;
    const title = i18nTranslate(`${translationPrefix}.instruction.title`);

    if (!title || title.includes('.instruction.title')) return null;

    return (
      <>
        <label
          htmlFor='instructions'
          className='form-control-label text-aqua-04 details-list-title'
        >
          <h3>{title}</h3>
        </label>
        {this.renderDetailList(translationPrefix)}
      </>
    );
  };

  render() {
    const { matrixField } = this.props;
    const { translationPrefix } = DETAIL_LIST[matrixField.name] || {};

    if (!translationPrefix) {
      return null;
    }

    return (
      <>
        {this.renderSubtitle(matrixField, translationPrefix)}
        {this.renderDetailsParagraph(matrixField, translationPrefix)}
        {this.renderInstructions(translationPrefix)}
      </>
    );
  }
}

MvrMatrixDocumentUploadDetail.propTypes = {
  matrixField: PropTypes.shape({
    name: PropTypes.string.isRequired,
    documentStatus: PropTypes.string,
    jurisdiction: PropTypes.string,
  }).isRequired,
  t: PropTypes.func.isRequired,
};
export default i18n.renderTranslation()(MvrMatrixDocumentUploadDetail);
